import { loadImage } from "./dom";

class Car360FrameLoader {
  stopped = false;
  frames = [];
  options = {};
  constructor(_frames, _options) {
    this.frames = _frames;
    this.options = _options;
    this.loadFrames().then();
  }
  async loadFrames() {
    await this.loadFrame(0);
  }
  async loadFrame(index) {
    if (!this.stopped) {
      await loadImage(this.frames[index]);
      this.options?.onProgress && this.options.onProgress(Math.ceil(((index + 1) * 100) / this.frames.length));
      if (index < this.frames.length - 1) {
        await this.loadFrame(index + 1);
      } else {
        this.options?.onComplete && this.options.onComplete();
      }
    }
  }
  destroy() {
    this.stopped = true;
  }
}
export default Car360FrameLoader;
